import { requestFactory, requestBase } from "@/plugins/axios";
export function getList(params) {
  return requestFactory({
    url: "/DailyData/findNowList",
    method: "GET",
    params,
  });
}

export function getRoleData(params) {
  return requestBase({
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    url: "v1/factory/worker/info",
    method: "GET",
    params,
  });
}
